import StatusBadge from "../../../../../utils/StatusBadge";
import Avatar from "../../../../../components/reusable/Avatar";

export const taskColumns = [
    {
        key: "title",
        label: "Task",
        sortable: true,
        render: (_, row) => (
            <div>
                <div style={{ fontWeight: 600 }}>
                    {row.title || "Untitled Task"}
                </div>

                {row.description && (
                    <div
                        style={{
                            fontSize: 13,
                            color: "#64748b",
                            marginTop: 3,
                        }}
                    >
                        {row.description}
                    </div>
                )}
            </div>
        ),
    },

    {
        key: "business",
        label: "Business",
        sortable: true,
    },

    {
        key: "employee",
        label: "Assigned To",
        sortable: true,

        render: (_, row) => {
            const employee = row.employee || {};

            return (
                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                        gap: 10,
                    }}
                >
                    <Avatar
                        image={employee.profile_image}
                        name={employee.name || "Unassigned"}
                        size="sm"
                    />

                    <div>
                        <div>
                            {employee.name || "Unassigned"}
                        </div>

                        {employee.role && (
                            <div
                                style={{
                                    fontSize: 12,
                                    color: "#64748b",
                                }}
                            >
                                {employee.role}
                            </div>
                        )}
                    </div>
                </div>
            );
        },
    },

    {
        key: "priority",
        label: "Priority",
        sortable: true,
    },

    {
        key: "status",
        label: "Status",
        sortable: true,
        render: (status) => (
            <StatusBadge status={status} />
        ),
    },

    {
        key: "due_date",
        label: "Due Date",
        sortable: true,
    },

    {
        key: "progress",
        label: "Progress",
        sortable: true,
        render: (value) => (
            <div style={{ minWidth: 90 }}>
                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                        gap: 8,
                    }}
                >
                    <div
                        style={{
                            flex: 1,
                            height: 6,
                            background: "#e2e8f0",
                            borderRadius: 999,
                            overflow: "hidden",
                        }}
                    >
                        <div
                            style={{
                                width: `${value || 0}%`,
                                height: "100%",
                                background: "#3b82f6",
                                borderRadius: 999,
                            }}
                        />
                    </div>

                    <span
                        style={{
                            fontSize: 12,
                            color: "#64748b",
                            minWidth: 32,
                        }}
                    >
                        {value || 0}%
                    </span>
                </div>
            </div>
        ),
    },
];
